import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** shadcn/ui コンポーネント (components/ui/*) 用の className 結合ヘルパー */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
